import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-sm font-medium transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#3D5A4C] disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-[#3D5A4C] text-white hover:bg-[#2C4238]',
    secondary: 'bg-[#E5E5E0] text-[#2D2D2D] hover:bg-[#D6D6D0]',
    outline: 'border border-[#3D5A4C] text-[#3D5A4C] hover:bg-[#3D5A4C] hover:text-white bg-transparent'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} {...props} data-id="element-132">
      {children}
    </button>;
}